// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + chunkId + ".main-" + {"205":"528ad7","554":"842881","857":"44696a"}[chunkId] + ".css";
};